import { ReactComponent as LogoSvg } from "svg/logo.svg";

export default function Logo() {
   return (
      <div className="logo" style={{
         display: "flex"
      }}>
         <LogoSvg style={{ margin: "auto" }}/>
      </div>
   )
}